

















































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class CIpfTableForObligation extends Vue {
    @Prop({
        required: true,
        default: null
    })
    private showData!: boolean;

    @Prop({
        required: true,
        default: false
    })
    isEmptyTotal!: boolean;

    @Prop({
        required: true,
        default: null
    })
    private tableData!: any;

    @Prop({
        required: true,
        default: null
    })
    private typeTable!: string;

    @Prop({
        required: true,
        default: false
    })
    private edit_access!: boolean;
    @Prop({
        required: true,
        default: false
    })
    private delete_access!: boolean;
    @Prop({
        required: true,
        default: null
    })
    private filterAttrs!: any;

    @Prop({
        required: true,
        default: null
    })
    private spfList!: any;

    private created() {
        this.$watch('filterAttrs', () => (this.open = false));
    }

    private tableFields = [
        // {
        //     key: 'action',
        //     label: ''
        // },
        {
            key: 'prg',
            label: 'ПРОГРАММА'
        },
        {
            key: 'ppr',
            label: 'ПОДПРОГРАММА'
        },
        {
            key: 'spf',
            label: 'СПЕЦИФИКА'
        },
        {
            key: 'expense_code',
            label: 'Проект'
        },
        {
            key: 'plan',
            label: `БЗ${this.filterAttrs.year}`
        },
        {
            key: 'deviation',
            label: 'Финансовый план на год',
            variant: 'secondary'
        },
        {
            key: 'january',
            label: 'Январь'
        },
        {
            key: 'february',
            label: 'Февраль'
        },
        {
            key: 'march',
            label: 'Март'
        },
        {
            key: 'april',
            label: 'Апрель'
        },
        {
            key: 'may',
            label: 'Май'
        },
        {
            key: 'june',
            label: 'Июнь'
        },
        {
            key: 'july',
            label: 'Июль'
        },
        {
            key: 'august',
            label: 'Август'
        },
        {
            key: 'september',
            label: 'Сентябрь'
        },
        {
            key: 'october',
            label: 'Октябрь'
        },
        {
            key: 'november',
            label: 'Ноябрь'
        },
        {
            key: 'december',
            label: 'Декабрь'
        }
    ];

    private checkMonth = [
        {
            key: 'january',
            check: 'january'
        },
        {
            key: 'february',
            check: 'checkFeb'
        },
        {
            key: 'march',
            check: 'checkMar'
        },
        {
            key: 'april',
            check: 'checkApr'
        },
        {
            key: 'may',
            check: 'checkMay'
        },
        {
            key: 'june',
            check: 'checkJun'
        },
        {
            key: 'july',
            check: 'checkJul'
        },
        {
            key: 'august',
            check: 'checkAug'
        },
        {
            key: 'september',
            check: 'checkSep'
        },
        {
            key: 'october',
            check: 'checkOct'
        },
        {
            key: 'november',
            check: 'checkNov'
        },
        {
            key: 'december',
            check: 'checkDec'
        }
    ]

    private open = false;

    private filter: any =  {
        prg: null,
        ppr: null,
        spf: null,
        expense_code: null,
        name_ru: null
    };

    private filtered = false;

    private showPopupIndex: string|null = null;

    private selectedSpfRow: any | null = null;

    private openModal(item: any) {
        this.selectedSpfRow = item;

        this.$bvModal.msgBoxConfirm(
            'Вы хотите выполнить разноску годовой суммы бюджета по месяцам?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'ДА',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    let monthlyShare = parseFloat((this.selectedSpfRow.plan / 12).toFixed(1))
                    let remain = this.selectedSpfRow.plan - 0
                    for (const mon of this.checkMonth) {
                        if (remain < monthlyShare) {
                            monthlyShare = remain
                        }
                        this.selectedSpfRow[mon.key] = monthlyShare;
                        remain -= monthlyShare;
                    }
                    if (remain !== 0) {
                        this.selectedSpfRow.december = parseFloat((this.selectedSpfRow.december + remain).toFixed(1));

                    }
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    private collapse: boolean = true;
    clkCollapseAll(data: any, collapse = true) {
        this.$set(data, 'collapse', collapse);
        if ('child_list' in data && data.child_list && data.child_list.length) {
            for (const el of data.child_list) { this.clkCollapseAll(el, collapse) }
        }
    }
    clkCollapse(prg: any = null, ppr: any = null, spf: any = null, collapse: boolean = false) {
        if (prg !== null) {
            let obj = this.tableData[prg]
            if (ppr !== null) {
                obj = obj.child_list[ppr]
            }
            if (spf !== null) {
                obj = obj.child_list[spf]
            }
            if (collapse) {
                this.clkCollapseAll(obj, collapse)
            }
            this.$set(obj, 'collapse', collapse);
        }
        else {
            this.collapse = collapse;
            for (const el of this.tableData) {
                this.clkCollapseAll(el, collapse)
            }
        }
    }

    private deleteSpec(data: any) {
        const body = { data: data, type: 'obligation' }
        this.$bvModal.msgBoxConfirm(
            'Вы действительно хотите удалить данную запись?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'ДА',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    this.$emit('deleteSpec', body)
                }
            })
            .catch(error => {
                this.makeToast('danger', 'Ошибка сохранения', error.toString());
            });
    }

    private makeToast(variant: any, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
    onChange(value: any, el: any, key: string) {
        if (value) {
            el[key] = parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, ''))
        } else {
            el[key] = 0;
        }
    }
    private inputFixed(item: any, field: any, value: number | string | null, digit: number) {
        item.hasChanges = true
        if (value) {
            this.$set(item, field, parseFloat(parseFloat(value.toString().replace(/,/g, '.').replace(/ /g, '')).toFixed(digit)));
        } else {
            this.$set(item, field, 0);
        }
    }

    private keyPress(event: any, pattern: any) {
        event.preventDefault();
        const regex = new RegExp(pattern);
        let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        const input = event.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        if (key === ',') {
            key = '.'
        }
        let moveCursor = 1
        let nextValue = input.value.substring(0, start) + key + input.value.substring(end);
        if (nextValue === '.') {
            nextValue = '0.'
            moveCursor = 2
        }
        if (!regex.test(nextValue)) {
            return false;
        }
        input.value = nextValue;
        input.setSelectionRange(start + moveCursor, start + moveCursor);
        // триггерим input event для Angular/Vue/etc
        input.dispatchEvent(new Event('input'));
        return true;
    } // вводит по заданному паттерну

    private keyup13(event: any) {
        event.preventDefault();
        // Isolate the node that we're after
        const currentNode = event.target;
        // find all tab-able elements
        const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
        // Find the current tab index.
        const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
        if (!event.target.value) {
            event.target.value = 0;
        }
        // select/focus the following element
        const targetIndex = (currentIndex + 1) % allElements.length;
        if (targetIndex < allElements.length) {
            allElements[targetIndex].select();
        }
    }// enter работает как tab

    private total(field: string) {
        let sum = 0;
        for (const row of this.tableData) {
            if (row.type === 4) {
                sum += parseFloat(row[field]);
            }
        }
        return parseFloat((Math.round(sum * 100) / 100).toFixed(1));
    } // итого по заданному полю

    private showPopup(index: string) {
        this.showPopupIndex = index;
    }
    private hidePopup() {
        this.showPopupIndex = null;
    }
}
